{
	"showLess": "Afficher moins",
	"showMore": "Afficher plus ({{remainingElements}})"
}
